// @ts-check
/* CUSTOM: Burgermenu på mobil (11/10 2026). Indlæses af snippets/custom-mobile-menu.
   1. Menuen starter under headeren, så logo, burger og kurv kan ses, mens den er åben.
      Placeringen måles i det øjeblik, burgeren trykkes (headeren er sticky og kan have
      announcement-baren over sig). CSS: --custom-nav-drawer-top i assets/custom-mobile-menu.css.
   2. Tryk på et andet ikon i headeren (søg, kurv) lukker menuen først – ellers lå den åben under
      kurven/søgningen. Burgeren selv lukker allerede menuen (Motions klik-udenfor).
   3. Gruppe nr. 2 og frem under et menupunkt bliver eget topniveau-punkt (se promoteGroups). */
(function () {
  const MOBILE = window.matchMedia('(max-width: 1023px)');

  /**
   * Hvor menuen skal starte (px fra toppen af skærmen). Lige under headeren, når hele headeren kan ses –
   * ellers 0 (fuld skærm med menuens eget luk-kryds, fx hvis man har scrollet lidt, før headeren bliver sticky).
   * @param {number} headerTop Headerens overkant i px fra toppen af skærmen
   * @param {number} headerBottom Headerens underkant i px fra toppen af skærmen
   * @param {number} viewportHeight Skærmens højde i px
   * @returns {number}
   */
  function getDrawerTop(headerTop, headerBottom, viewportHeight) {
    if (headerTop < 0 || !(headerBottom > 0) || headerBottom > viewportHeight / 2) return 0;
    // floor (ikke round): headerens højde er ofte et kommatal (fx 109,6px). Afrundet op opstod en sprække under 1px,
    // hvor billedet bag menuen skinnede igennem som en tyk, mønstret streg over SMYKKER (iPhone, 13/10 2026).
    // Rundet ned overlapper menuen headerens underkant en anelse i stedet.
    return Math.floor(headerBottom);
  }

  /** @returns {HTMLElement | null} */
  function getDrawer() {
    return document.getElementById('NavDrawer');
  }

  function placeDrawer() {
    const drawer = getDrawer();
    const header = document.querySelector('.site-header');
    if (!drawer || !header) return;

    const rect = header.getBoundingClientRect();
    const top = MOBILE.matches ? getDrawerTop(rect.top, rect.bottom, window.innerHeight) : 0;
    drawer.style.setProperty('--custom-nav-drawer-top', top + 'px');
    drawer.classList.toggle('custom-nav-drawer--under-header', top > 0);
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    const closeButton = drawer.querySelector('.js-drawer-close');
    if (closeButton instanceof HTMLElement) closeButton.click();
  }

  // Capture-fase: kører før Motions egne klik-handlere
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const burger = target.closest('.js-drawer-open-nav');
    if (burger) {
      placeDrawer();
      return;
    }

    if (target.closest('.site-header :is(.js-search-header, .js-drawer-open-cart)')) {
      closeDrawer();
    }
  }, true);

  /**
   * 3. Grupper fra desktop-megamenuen (fx Kategorier + Personaliseret under Smykker): den første gruppe
   *    står stadig direkte under topniveauet uden overskrift (CSS), og hver følgende gruppe bliver sit eget
   *    topniveau-punkt lige efter (ejers ønske 12/10 2026). Topniveau-punktet klones, så markup, pil og
   *    fold-ud er Motions egne.
   * @returns {number} Antal nye topniveau-punkter
   */
  function promoteGroups() {
    const drawer = getDrawer();
    const nav = drawer && drawer.querySelector('.mobile-nav');
    if (!drawer || !nav) return 0;

    let count = 0;
    Array.from(nav.children).forEach(function (top) {
      const list = top.querySelector(':scope > .mobile-nav__sublist');
      if (!list || !list.id) return;
      const groups = Array.from(list.querySelectorAll(':scope > .collapsible-content__inner > ul.mobile-nav__sublist > .mobile-nav__item'))
        .filter(function (item) { return item.querySelector(':scope > .mobile-nav__sublist'); });

      let after = top;
      groups.slice(1).forEach(function (group) {
        const heading = group.querySelector(':scope > .mobile-nav__child-item :is(.mobile-nav__faux-link, a.mobile-nav__link)');
        const clone = /** @type {HTMLElement} */ (top.cloneNode(true));
        const cloneList = clone.querySelector(':scope > .mobile-nav__sublist');
        const label = clone.querySelector(':scope > .mobile-nav__has-sublist :is(.mobile-nav__faux-link, a.mobile-nav__link)');
        const items = cloneList && cloneList.querySelector(':scope > .collapsible-content__inner > ul.mobile-nav__sublist');
        if (!heading || !cloneList || !label || !items) return;

        count += 1;
        const newId = list.id + '-custom-' + count;
        cloneList.id = newId;
        clone.querySelectorAll('[aria-controls="' + list.id + '"]').forEach(function (el) { el.setAttribute('aria-controls', newId); });
        label.textContent = (heading.textContent || '').trim();
        if (label instanceof HTMLAnchorElement) {
          const link = heading.closest('.mobile-nav__child-item')?.querySelector('a.mobile-nav__link');
          if (link) label.href = link.getAttribute('href') || label.href;
          label.id = 'Label-' + newId;
          clone.querySelectorAll('[aria-labelledby]').forEach(function (el) {
            if (el.closest('.mobile-nav__has-sublist')) el.setAttribute('aria-labelledby', label.id);
          });
        }
        clone.classList.remove('mobile-nav__item--active');
        cloneList.querySelectorAll('.megamenu__promo').forEach(function (el) { el.remove(); });
        items.replaceChildren(group); // gruppen flyttes – den står ikke længere under det oprindelige punkt
        after.after(clone);
        after = clone;
      });
    });

    // @ts-ignore – Motions globale theme-objekt (assets/theme.js)
    if (count && window.theme && window.theme.collapsibles) window.theme.collapsibles.init(drawer);
    return count;
  }

  promoteGroups();

  // @ts-ignore – til isoleret test i konsollen
  window.CustomMobileMenu = { getDrawerTop: getDrawerTop, promoteGroups: promoteGroups };
})();
